import Dexie from 'dexie'

const db = new Dexie('wispal')
db.version(7)
    .stores({
        conversations:
            '_id, *participantDetails.userId, lastMessage, updatedAt',
        messages:
            '_id, [conversationId+createdAt], sender, receiver, content, contentType, translations, *readBy, *receivedBy, updatedAt, [conversationId+sender], [receiver+contentType], [conversationId+receiver+contentType], mediaObjectRef._id, order._id',
        appConfig: '++id',
        users: '_id, username, displayname, profileImage, onlineStatus.status, onlineStatus.last_seen, createdAt, updatedAt',
    })
    .upgrade((tx) => {
        console.log(
            `Database schema upgrade processed for version. Transaction version: ${tx.verno}`
        )
    })

export default db

export * from './messages.js'
export * from './conversations.js'
export * from './users.js'
export * from './appConfig.js'
export * from './media.js'
export * from './clear.js'
